function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78.222069mm",
    height: "78.221886mm",
    viewBox: "0 0 78.222069 78.221886",
    id: "svg840",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs837"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient845"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1
    },
    offset: 0,
    id: "stop843"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-20.14618,-75.476796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 59.257214,
    cy: 114.58774,
    rx: 35.855999,
    ry: 35.855907
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4550",
    transform: "matrix(0.50251001,0,0,0.50251001,4.2722882,39.965003)",
    style: {
      strokeWidth: 1.99002
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 10.9451,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect3902",
    width: 83.876938,
    height: 46.136395,
    x: 63.061806,
    y: 125.4318,
    ry: 8.6359434,
    rx: 8.2807379
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 10.945,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect4008",
    width: 9.3702698,
    height: 18.432322,
    x: 146.40904,
    y: 139.28384,
    rx: 0,
    ry: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.4520e08364cd9dd6ec671a54152aee05.svg";
export { ForwardRef as ReactComponent };